import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { Link } from '../../../components/link/link';
import { NAVIGATION } from '../../../config';
import { Project } from '../../../types/entities';
import i18n from '../../../utils/i18n/i18n';
import styles from './project-select-tooltip.scss';
import { Text } from '@wix/design-system';

const MAXIMUM_ITEMS_SHOWN_ON_TOOLTIP: number = 6;

interface Props {
  project: Project;
  projects: Project[];
}

export class ProjectSelectTooltip extends React.Component<Props> {
  private tooltip;

  public hideTooltip() {
    this.tooltip && this.tooltip.hide();
  }

  public isShowSeeAllLink(): boolean {
    const { projects } = this.props;

    return _.size(projects) - 1 > MAXIMUM_ITEMS_SHOWN_ON_TOOLTIP;
  }

  public renderLinks() {
    const { projects, project } = this.props;

    const firstProjects: ArrayLike<Project> = _(projects)
      .filter((item: Project) => item.id !== project.id)
      .take(MAXIMUM_ITEMS_SHOWN_ON_TOOLTIP)
      .value();

    return (
      <div
        className={styles.links}
        data-hook="sidebar-project-select-tooltip-content"
      >
        {_.map(firstProjects, (project: Project) => (
          <Link
            key={project.id}
            dataHook="sidebar-project-select-tooltip-content-link"
            onClick={this.hideTooltip.bind(this)}
            className={classNames(styles.link)}
            path={NAVIGATION.PROJECT_OVERVIEW}
            projectId={project.id}
          >
            <Text size="small">{project.name}</Text>
          </Link>
        ))}

        {this.isShowSeeAllLink() && (
          <Link
            onClick={this.hideTooltip.bind(this)}
            path={NAVIGATION.PROJECTS_STATE}
          >
            <Text size="small">
              {i18n.t('project-select-tooltip.link.see-all')}
            </Text>
          </Link>
        )}
      </div>
    );
  }

  public render() {
    const { project } = this.props;

    return (
      <div className={styles.projectSelectTooltip}>
        <span className={styles.projectName} title={project.name}>
          {project.name}
        </span>
      </div>
    );
  }
}
